import { ActivityEntityName } from '../../../../entities';
import { getSchema, MergeField, MergeSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.Invoice
})
export class InvoiceAccountMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    friendlyName: string;

    @MergeField()
    type: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;

    @MergeField()
    contactName: string;

    @MergeField({ hidden: true })
    contactId: string;

    @MergeField()
    taxId: string;

}

export const InvoiceAccountMergeSchema = getSchema(InvoiceAccountMergeData);